import { ReactNode } from 'react';
import styles from './SubHeader.module.css';

interface SubHeaderProps {
  children?: ReactNode;
  title?: string;
}

export function SubHeader({ children, title }: SubHeaderProps) {
  return (
    <div className={styles.subHeader}>
      {title && <h2 className={styles.title}>{title}</h2>}
      {children && <div className={styles.actions}>{children}</div>}
    </div>
  );
}
